import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Mail } from "lucide-react";
import { useNavigate, useLocation } from "react-router";
import { Input } from "../../primitives/Input";
import { Button } from "../../primitives/Button";
import { useAuth } from "../../provider";
import { AuthLayout } from "./AuthLayout";
export function ForgotPasswordCheckEmail() {
    const navigate = useNavigate();
    const location = useLocation();
    const { authClient } = useAuth();
    const email = location.state?.email ?? "";
    const [code, setCode] = useState("");
    const [cooldown, setCooldown] = useState(60);
    const [canResend, setCanResend] = useState(false);
    useEffect(() => {
        if (cooldown > 0) {
            const timer = setTimeout(() => {
                setCooldown(cooldown - 1);
            }, 1000);
            return () => clearTimeout(timer);
        }
        else {
            setCanResend(true);
        }
    }, [cooldown]);
    const handleResend = async () => {
        if (canResend && email) {
            setCooldown(60);
            setCanResend(false);
            try {
                await authClient.forgotPassword(email);
            }
            catch {
                // Silently fail on resend
            }
        }
    };
    const handleContinue = () => {
        navigate("/auth/reset-password", { state: { email, code } });
    };
    return (_jsxs(AuthLayout, { centred: true, children: [_jsx("div", { className: "flex justify-center mb-6", children: _jsx("div", { className: "w-12 h-12 flex items-center justify-center text-duvi-accent", children: _jsx(Mail, { className: "w-12 h-12" }) }) }), _jsx("h1", { className: "text-duvi-text-primary mb-3", style: {
                    fontSize: "var(--text-xl)",
                    fontWeight: "var(--font-weight-semibold)",
                    lineHeight: "var(--line-height-heading)",
                }, children: "Check your email" }), _jsxs("p", { className: "text-duvi-text-secondary mb-6", style: {
                    fontSize: "var(--text-sm)",
                    lineHeight: "var(--line-height-body)",
                }, children: ["We've sent a verification code to ", email || "your email", ". Enter it below to reset your password."] }), _jsxs("div", { className: "mb-4 text-left", children: [_jsx("label", { className: "block text-duvi-text-primary mb-2", style: { fontSize: "var(--text-sm)" }, children: "Verification code" }), _jsx(Input, { value: code, onChange: (e) => setCode(e.target.value), placeholder: "Enter 6-digit code", maxLength: 6, "data-testid": "forgot-password-code" })] }), _jsx(Button, { variant: "primary", className: "w-full mb-4", onClick: handleContinue, disabled: code.length < 6, "data-testid": "forgot-password-continue", children: "Continue" }), _jsx("div", { className: "mb-3", children: _jsx("button", { onClick: handleResend, disabled: !canResend, className: `transition-colors ${canResend
                        ? "text-duvi-text-secondary hover:text-duvi-text-primary cursor-pointer"
                        : "text-duvi-text-muted/50 cursor-not-allowed"}`, style: { fontSize: "var(--text-xs)" }, children: canResend ? "Resend code" : `Resend in ${cooldown}s` }) }), _jsx("div", { children: _jsx("button", { onClick: () => navigate("/auth/password"), className: "text-duvi-text-secondary hover:text-duvi-text-primary transition-colors", style: { fontSize: "var(--text-xs)" }, children: "Back to sign in" }) })] }));
}
//# sourceMappingURL=ForgotPasswordCheckEmail.js.map